module.exports = __webpack_public_path__ + "img/flag-viewpoint--icon--gray.ea066450.svg";